import { useCallback, useEffect, useState } from 'react';
import { useTimer } from '@givebutter/react-util';

const CUTOFF = 0;
const DELAY = 0;

type QueueCallback = (...args: any) => void | Promise<void>;

const useSynchronousQueue = <T extends QueueCallback>(delay = DELAY) => {
  const [queue, setQueue] = useState<T[]>([]);
  const { countdown, reset: resetCountdown } = useTimer(delay);

  const enqueue = useCallback(
    (data: T[]) => setQueue(currentQueue => [...data, ...currentQueue]),
    [],
  );

  const dequeue = useCallback(async () => {
    const nextToPop = queue[queue.length - 1];
    await nextToPop();
    setQueue(currentQueue => {
      return currentQueue.slice(0, -1);
    });
    resetCountdown();
  }, [queue, resetCountdown]);

  useEffect(() => {
    if (queue.length > CUTOFF && countdown === 0) {
      dequeue();
    }
  }, [countdown, dequeue, queue]);

  return {
    enqueue,
    queue,
  };
};

export { useSynchronousQueue };
export type { QueueCallback };
